import React from "react"

import { SearchProduct } from "@lib/clients/nelo-api-client"
import { getModifiedUrl } from "@modules/nelo-search/util/get-modified-url"
interface SearchResultsProps {
  results: SearchProduct[]
  onPress: (url: string) => void
  children?: React.ReactNode
}

const SearchResults: React.FC<SearchResultsProps> = ({ results, onPress, children }) => {
  return (
    <div
      className="max-h-[300px] w-full overflow-y-auto rounded-lg bg-white py-2 shadow-lg"
      style={{
        boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15)",
      }}
    >
      {results.map((result, index) => (
        <div
          key={result.productUrl}
          onClick={() => onPress(getModifiedUrl(result.productUrl))}
          className="flex cursor-pointer items-center px-4 py-3 hover:bg-gray-100"
        >
          <div className="mr-3 h-5 w-5 shrink-0">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              className="h-full w-full text-gray-500"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z" />
            </svg>
          </div>
          <span className="truncate font-nunito text-sm text-black">{result.name}</span>
        </div>
      ))}
      {children}
    </div>
  )
}

export default SearchResults
